<template>
    <div class="user-item" :style="{background:ParentPage==='FeePay'?'rgba(255,255,255,1)':''}">
        <div class="item-title">
            <div class="title-wrapper">
                <div class="title-lalel" style="font-size:14px;font-weight:400;">用户号：</div>
                <div class="title-value">{{user.fpactno}}</div>
            </div>
            <div v-if="ParentPage!=='FeePay'&&user.fee==='0'||!user.fee" class="title-btn">
                <van-button @click="selectClick()" plain type="info" size="small" color="#3F8BEF">
                    选择返回
                </van-button>
            </div>
        </div>
        <div class="item-info">
            <div class="info-lalel">缴费号：</div>
            <div class="info-value">{{user.fuserno}}</div>
        </div>
        <div class="item-info">
            <div class="info-lalel">户名：</div>
            <div class="info-value">{{user.fname}}</div>
        </div>
        <div class="item-info">
            <div class="info-lalel">用水地址：</div>
            <div class="info-value">{{user.ffixaddr}}</div>
        </div>
        <div v-if="user.fee&&user.fee!=='0'" class="item-title item-fee">
            <div class="title-wrapper">
                <div class="title-lalel">欠费金额：</div>
                <div class="title-value">
                    <span class="fee-color">{{user.fee}}</span>&nbsp;元
                </div>
            </div>
            <div class="title-btn">
                <van-button size="small" type="info" class="search-btn" @click="rightNowPay(user)">
                    立即缴纳
                </van-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'UserItem',
        components: {},
        props: {
            ParentPage: String,
            user: Object
        },
        data() {
            return {}
        },
        methods: {
            selectClick() {
                this.$emit('selectClick', this.user)
            },
            rightNowPay(item) {
                if(!this.$comm.titleShow()){
                    this.$comm.userPay(item)
                }else{
                    location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa92e301d87f1aefe&redirect_uri=https%3A%2F%2Fwww.dlmeasure.com%2Fstatic%2Fduliang%2Fweixin%2Fapps%2Fbxzls%2Fms2%2F%23business%2Fwater&response_type=code&scope=snsapi_userinfo&state=bxzls#wechat_redirect'
                }
            }
        },
    }
</script>

<style lang="less" scoped>
    .user-item {
        background: #EEF6FF;
        border-radius: 4px;
        padding: 10px 6px;

        .item-title {
            display: flex;
            justify-content: space-between;

            .title-wrapper {
                width: calc(~"100% - 85px");
                display: flex;
                justify-content: space-between;

                .title-label {
                    width: 80px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(33, 33, 33, 1);
                }

                .title-value {
                    width: calc(~"100% - 80px");
                    font-size: 14px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: rgba(33, 33, 33, 1);

                    .fee-color {
                        font-size: 16px;
                        font-weight: Semibold;
                        color: #FF0000
                    }
                }
            }

            .title-btn {
                width: 85px;
                text-align: right;
                height: 30px;
                border-radius: 3px;
            }
        }

        .item-info {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(33, 33, 33, 1);

            .info-label {
                width: 80px;
            }

            .info-value {
                width: calc(~"100% - 80px");
            }
        }

        .item-fee {
            margin-top: 21px;
            border-top: 1px solid #cccccc;
            height: 62.5px;
            line-height: 62.5px;
        }
    }
</style>